export default __webpack_public_path__ + "static/media/banner3.3959f3a0.png";